"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoTProvider = exports.HoTUrl = exports.ProviderEventEmitter = exports.WalletRpcMethod = void 0;
const communication_1 = require("./communication");
const eventemitter3_1 = require("eventemitter3");
const storage_1 = require("./storage");
const utils_1 = require("./utils");
var WalletRpcMethod;
(function (WalletRpcMethod) {
    WalletRpcMethod["eth_chainId"] = "eth_chainId";
    WalletRpcMethod["eth_accounts"] = "eth_accounts";
    WalletRpcMethod["eth_requestAccounts"] = "eth_requestAccounts";
    WalletRpcMethod["eth_sendTransaction"] = "eth_sendTransaction";
    WalletRpcMethod["eth_signTypedData_v4"] = "eth_signTypedData_v4";
    WalletRpcMethod["wallet_switchEthereumChain"] = "wallet_switchEthereumChain";
    WalletRpcMethod["personal_sign"] = "personal_sign";
})(WalletRpcMethod || (exports.WalletRpcMethod = WalletRpcMethod = {}));
class ProviderEventEmitter extends eventemitter3_1.EventEmitter {
}
exports.ProviderEventEmitter = ProviderEventEmitter;
exports.HoTUrl = [
    "https://home-of-token-web.vercel.app/", // main
    "https://web.token.im/",
    "https://web.qianbao.io/",
    "https://web.imstaging.works/", // staging
    "https://home-of-token-web-test.vercel.app/", // test
    "http://localhost:3000/", // local
];
const allowedChain = [
    { chainId: 42161, rpcUrl: "https://arb1.arbitrum.io/rpc" },
    { chainId: 10, rpcUrl: "https://optimism.llamarpc.com" },
    { chainId: 11155111, rpcUrl: "https://rpc.sepolia.org" },
];
class HoTProvider extends ProviderEventEmitter {
    constructor(options) {
        var _a, _b, _c;
        super();
        this.accounts = [];
        this.isHoT = true;
        const defaultUrl = exports.HoTUrl[1];
        // check if url is from HoT
        if (options.url && exports.HoTUrl.includes(options.url)) {
            (0, storage_1.setSessionStorage)((0, storage_1.getKey)("url"), options.url);
        }
        else {
            options.url = (_a = (0, storage_1.getSessionStorage)((0, storage_1.getKey)("url"))) !== null && _a !== void 0 ? _a : defaultUrl;
        }
        this.communicator = new communication_1.Communicator(`${options.url}/wallet`);
        this.accounts = (_b = (0, storage_1.getLocalStorage)((0, storage_1.getKey)("accounts"))) !== null && _b !== void 0 ? _b : [];
        this.chain = (_c = (0, storage_1.getLocalStorage)((0, storage_1.getKey)("activeChainId"))) !== null && _c !== void 0 ? _c : {
            id: 42161,
            rpcUrl: "https://arb1.arbitrum.io/rpc",
        };
    }
    request(args) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("[HoT Provider] request", args);
            if (this.accounts.length === 0 &&
                args.method !== WalletRpcMethod.eth_requestAccounts) {
                throw new Error("Should request accounts before sending request");
            }
            try {
                switch (args.method) {
                    case WalletRpcMethod.eth_accounts:
                        return this.getAccounts();
                    case WalletRpcMethod.eth_requestAccounts:
                        return this.handleRequestAccounts(args);
                    case WalletRpcMethod.wallet_switchEthereumChain:
                        return this.handleSwitchChain(args);
                    case WalletRpcMethod.eth_sendTransaction:
                    case WalletRpcMethod.eth_signTypedData_v4:
                        return this.sendRequestToPopup(args);
                    case WalletRpcMethod.eth_chainId:
                        return this.getChainId();
                    default:
                        const { result } = yield (0, utils_1.rpc)(this.chain.rpcUrl, args);
                        return result;
                }
            }
            catch (error) {
                throw this.wrapError(error);
            }
        });
    }
    sendRequestToPopup(request) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.communicator.waitForPopupLoaded();
            console.log("[HoT Provider] sendRequestToPopup", request);
            const response = yield this.communicator.postRequestAndWaitForResponse({
                id: crypto.randomUUID(),
                chainId: this.chain.id,
                method: request.method,
                params: request.params,
            });
            console.log("[HoT Provider] response from request", request.method, response);
            if (response.error) {
                throw this.wrapError(response.error);
            }
            return response.result;
        });
    }
    getAccounts() {
        console.log("[HoT Provider] getAccounts", this.accounts);
        return this.accounts;
    }
    getChainId() {
        return this.chain.id;
    }
    handleRequestAccounts(request) {
        return __awaiter(this, void 0, void 0, function* () {
            // if (this.accounts.length > 0) {
            //   return this.accounts;
            // }
            var _a;
            // @ts-ignore
            const requestChainId = (_a = request === null || request === void 0 ? void 0 : request.params) === null || _a === void 0 ? void 0 : _a.chainId;
            if (requestChainId) {
                // @ts-ignore
                const chain = allowedChain.find((chain) => chain.chainId === requestChainId);
                if (chain) {
                    this.chain = {
                        id: chain.chainId,
                        rpcUrl: chain.rpcUrl,
                    };
                }
            }
            const result = (yield this.sendRequestToPopup(request));
            const accounts = result.accounts;
            this.accounts = accounts;
            (0, storage_1.setLocalStorage)((0, storage_1.getKey)("accounts"), this.accounts);
            (0, storage_1.setLocalStorage)((0, storage_1.getKey)("availableChainList"), result.availableChainList);
            console.log("[HoT Provider] handleRequestAccounts", accounts);
            this.updateChain(result.availableChainList[0].id);
            return accounts;
        });
    }
    handleSwitchChain(request) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!Array.isArray(request.params) ||
                request.params.length === 0 ||
                !("chainId" in request.params[0])) {
                return {
                    code: -32602,
                    message: "Invalid request params",
                };
            }
            // check if the chain is available in the list
            const { chainId: chainIdHex } = (_a = request === null || request === void 0 ? void 0 : request.params) === null || _a === void 0 ? void 0 : _a[0];
            const chainId = parseInt(chainIdHex, 16);
            const isChainAvailable = this.updateChain(chainId);
            if (isChainAvailable) {
                return null; // success
            }
            return {
                code: 4902,
                message: "Unrecognized or unsupported chain ID.",
            };
        });
    }
    wrapError(error) {
        if (error instanceof Error) {
            return Object.assign(Object.assign({}, error), { code: error.code || -32603, data: error.data });
        }
        return {
            name: "ProviderRpcError",
            message: "Unknown error",
            code: -32603, // Internal error
            data: error,
        };
    }
    updateChain(chainId) {
        const availableChainList = (0, storage_1.getLocalStorage)((0, storage_1.getKey)("availableChainList"));
        console.log("availableChainList"), availableChainList;
        const chain = availableChainList.find((chain) => chain.id === chainId);
        if (!chain) {
            return false;
        }
        this.chain = chain;
        (0, storage_1.setLocalStorage)((0, storage_1.getKey)("activeChainId"), chain);
        return true;
    }
}
exports.HoTProvider = HoTProvider;
